/** @format */
import { css } from 'styled-components';

import { theme } from '@toucan/client/global/theme';

/* eslint-disable @typescript-eslint/no-unsafe-argument -- Legacy code: do not use as an example. */
export const styles = css`
    padding: var(--layout-spacing-24) 0 var(--layout-spacing-12) 0;

    .aside-menu__title {
        padding: var(--layout-spacing-24);
        .search-filter-menu__heading {
            margin-bottom: var(--layout-spacing-4);
        }
    }

    .search-filter-menu__title-extra-content {
        display: flex;
        align-items: center;
        gap: var(--layout-spacing-24);
    }

    .search-filter-menu__aside > aside {
        padding: 0;

        .aside-menu__content {
            padding: 0;
            > *:not(
                    .search-filter-menu__footer,
                    .search-filter-menu__advanced-filters
                ) {
                padding: 0 var(--layout-spacing-24);
            }
        }
    }

    .price-filter {
        margin-bottom: var(--layout-spacing-24);
    }

    .search-filter-menu__advanced-filters {
        margin-bottom: var(--layout-spacing-24);

        .content > *,
        .collapsible-aside-title-container {
            padding: 0 var(--layout-spacing-24);
        }

        .content-container[aria-hidden='false'],
        .content-container[aria-hidden='false'] .content {
            overflow: visible;
        }
    }

    .search-filter-menu__footer {
        display: flex;
        align-items: center;
        gap: var(--layout-spacing-16);
        padding: var(--layout-spacing-16);
        border-top: 1px solid var(--colors-border-primary);
        position: relative;

        button {
            min-width: 25rem;
        }

        .search-filter-menu__no-results-message {
            ${theme.typography.body_small};
        }
    }
`;
/* eslint-enable @typescript-eslint/no-unsafe-argument -- Legacy code: do not use as an example. */
